import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import { companiesConfig } from '../store/apis/companies/companiesConfig'; // Adjust the path as needed

const useFetchMultipleAppointmentStatistics = (selectedCompany, appointmentIds) => {
    const [statistics, setStatistics] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const prevAppointmentIdsRef = useRef();

    useEffect(() => {
        if (!selectedCompany || !appointmentIds || appointmentIds.length === 0) {
            return;
        }

        const haveIdsChanged = appointmentIds.some((id, index) => prevAppointmentIdsRef.current?.[index] !== id);
        if (!haveIdsChanged) {
            return; 
        }

        prevAppointmentIdsRef.current = appointmentIds;

        const fetchStatistics = async () => {
            setIsLoading(true);
            setError(null);

            try {
                const apiKey = companiesConfig[selectedCompany]?.apiKey;
                const responses = await Promise.all(appointmentIds.map(id =>
                    axios.get(`https://publicapi.e-regnskab.dk/Appointment/Standard/Statistics/${id}`, {
                        headers: { apiKey: apiKey }
                    })
                ));
                const fetchedStatistics = responses.map(response => response.data);
                setStatistics(fetchedStatistics);
            } catch (err) {
                setError(err.message || 'An error occurred');
            } finally {
                setIsLoading(false);
            }
        };

        fetchStatistics();
    }, [selectedCompany, appointmentIds]);

    return { statistics, isLoading, error };
};

export default useFetchMultipleAppointmentStatistics;